<template>
	<div>
		<div style="margin:15px 0">
			<!-- 面包屑 -->
			<el-breadcrumb separator-class="el-icon-arrow-right">
				<el-breadcrumb-item :to="{ path: '/couponPackage' }">券包管理</el-breadcrumb-item>
				<el-breadcrumb-item v-if="type===0" :to="{ path: '/scenicList' }">新增券包</el-breadcrumb-item>
				<el-breadcrumb-item>{{ type === 0 ? '添加' : '编辑' }}券包</el-breadcrumb-item>
			</el-breadcrumb>
		</div>
		<el-card class="box-card">
			<el-form :rules="rules" :model="formList" ref="formList">
				<el-form-item label="券包名称：" label-width="140px" prop="name">
					<el-input style="width: 400px" v-model="formList.name" placeholder="例：30元超值优惠券包"></el-input>
				</el-form-item>
				<el-form-item label="景点名称：" label-width="140px">
					<el-input style="width: 400px" v-model="formList.area_name" disabled></el-input>
				</el-form-item>
				<el-form-item label="券包景点名称：" label-width="140px" prop="scenic_name">
					<el-input style="width: 400px" v-model="formList.scenic_name" placeholder="请输入券包景点名称"></el-input>
				</el-form-item>
				<el-form-item label="券包价格：（元）" label-width="140px" prop="price_now">
					<el-input-number v-model.number="formList.price_now" style="width: auto" :precision="2" :min="0"
									 placeholder="券包价格"></el-input-number>
					<!--					<el-input style="width: auto" v-model.number="formList.price_now" placeholder="请输入券包价格"></el-input>-->
				</el-form-item>
				<el-form-item label="券包原价：（元）" label-width="140px" prop="price_origin">
					<el-input-number v-model.number="formList.price_origin" style="width: auto" :precision="2" :min="0"
									 placeholder="券包原格"></el-input-number>
					<!--					<el-input style="width: auto" v-model.number="formList.price_origin" placeholder="请输入券包原"></el-input>-->
				</el-form-item>
				<el-form-item label="券包图片：" label-width="140px" prop="picture" v-loading="loadImg">
					<el-upload class="avatar-uploader"
							   :action="uploadPath"
							   :show-file-list="false"
							   :before-upload="upLoadBefore"
							   :on-error="upLoadError"
							   :on-success="upLoadSuccess">
						<img v-if="formList.picture" :src="formList.picture" class="avatar" alt="">
						<i v-else class="el-icon-plus avatar-uploader-icon"></i>
					</el-upload>
				</el-form-item>
				<h4>券包详情</h4>
				<editor v-model="formList.description" :init="editorInit"/>
			</el-form>
		</el-card>
		<span slot="footer" class="dialog-footer">
        <el-button @click="cancel">取 消</el-button>
        <el-button type="primary" @click="save">下一步</el-button></span>
	</div>
</template>

<script>
import Editor from '@tinymce/tinymce-vue'
import qs from "qs";
import coupon from "../api/coupons";
import {uploadPath} from "../axios/index";

export default {
	components: {Editor},
	props: {
		pageSize: {
			type: Number,
			default: 10,
		}
	},
	data() {
		return {
			uploadPath,
			loadImg: false,
			formList: {
				id: undefined,
				area_name: '',
				name: '',
				price_now: 10,
				price_origin: 10,
				picture: '',
				area_id: undefined,
				scenic_name: '',
				description: '',
			},
			type: 0,
			editorInit: {
				language: 'zh_CN',
				height: '400px',
				convert_urls: false,
				plugins: [
					'advlist anchor autolink autosave code codesample colorpicker colorpicker contextmenu directionality emoticons fullscreen hr  imagetools importcss insertdatetime link lists media nonbreaking noneditable pagebreak paste preview print save searchreplace spellchecker tabfocus table template textcolor textpattern visualblocks visualchars wordcount image'
				],
				toolbar: [
					'searchreplace bold italic underline strikethrough alignleft aligncenter alignright outdent indent  blockquote undo redo removeformat subscript superscript code codesample',
					'hr bullist numlist  charmap preview anchor pagebreak insertdatetime media table emoticons forecolor backcolor fullscreen image'
				],
				images_upload_handler: function (blobInfo, success, failure) {
					// const img = "data:image/jpeg;base64," + blobInfo.base64();
					// success(img);
					const formData = new FormData()
					formData.append('file', blobInfo.blob())
					coupon.upImg(formData).then(res => {
								success(res)
							}).catch(() => {
								failure('上传失败，请重新上传')
							})
				}
			},
			rules: {
				name: [{required: true, message: '请输入券包名称', trigger: 'blur'},],
				scenic_name: [{required: true, min: 1, max: 20, message: '请输入券包景点名称', trigger: 'blur'},],
				price_now: [{required: true, message: '请输入券包价格', trigger: 'blur'},],
				price_origin: [{required: true, message: '请输入券包原价', trigger: 'blur'},],
				picture: [{required: true, message: '请选择券包图片', trigger: 'blur'},]
			},
		}
	},
	mounted() {
		let query = this.$route.query;
		this.type = parseInt(query.type);
		if (this.type === 0) {
			this.formList.area_id = query.area_id;
			this.formList.scenic_name = query.area_name;
			this.formList.area_name = query.area_name;
		} else if (this.type === 1) {
			this.getCouponPackageList(this.$datas.couponPackage.id);
		} else {
			this.$confirm('请返回重试！', '提示', {
				confirmButtonText: '确定',
				showCancelButton: false,
				type: 'warning'
			}).then(() => {
				this.$router.push({
					path: "/couponPackage"
				});
			})
		}
	},
	methods: {
		getCouponPackageList(id) {
			coupon.getCouponPackageList({id}).then(res => {
				this.formList = res.list[0];
			})
		},
		add(i, data) {//添加券包
			this.formList.area_name = data.area_name;
			this.pop = true;
			console.log(i, data)
		},
		save() {//保存
			let formList = this.formList;
			this.$refs.formList.validate(res => {
				if (res) {
					if (this.type === 0) {//添加
						coupon.addCouponPackage(formList).then(id => {
							this.$datas.couponPackage.id = id;
							this.$router.push({
								path: "/couponSetting",
								query: {id}
							});
						}).catch(err => {
							this.$message({
								type: 'error',
								message: err.msg
							});
						})
					} else if (this.type === 1) {//修改
						coupon.updateCouponPackage(formList).then(res => {
							this.$router.push({
								path: "/couponSetting",
								query: {id: formList.id}
							});
						}).catch(err => {
							this.$message({
								type: 'error',
								message: err.msg
							});
						})
					}
				}
			})
		},
		cancel() {
			if (this.type === 0) {
				this.$router.push({
					path: "/scenicList",
					query: {}
				});
			} else {
				this.$router.push({
					path: "/couponPackage",
					query: {}
				});
			}
		},
		upLoadBefore(res) {
			this.loadImg = true;
		},
		upLoadError(err) {
			console.log(err, 77)
			this.$message({
				type: 'error',
				message: '上传出错'
			});
			this.loadImg = false;
		},
		upLoadSuccess(res, file) {//上传图片
			if (res.code === 0) {
				this.formList.picture = res.data;
				this.loadImg = false;
			}
		},
		packageLineAdd() {
			this.formList.tableList.push({
				original_price: '',
			})
		},
		handleDeletePackageLine(index) {
			this.bulletList.splice(index, 1)
		},
	},
}
</script>

<style>
p span {
	margin: 0 25px;
}

.avatar-uploader .el-upload {
	border: 1px dashed #d9d9d9;
	border-radius: 6px;
	cursor: pointer;
	position: relative;
	overflow: hidden;
}

.avatar-uploader .el-upload:hover {
	border-color: #409EFF;
}

.avatar-uploader-icon {
	font-size: 28px;
	color: #8c939d;
	width: 178px;
	height: 178px;
	line-height: 178px;
	text-align: center;
}

.avatar {
	width: 178px;
	height: 178px;
	display: block;
}
</style>



// WEBPACK FOOTER //
// src/components/coupons.vue